import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { WrapAppRoute } from 'router'
import { AbilityContext } from "components/Permissions/Can";

const CreateRouter = ({ routes }) => {
    const ability = useContext(AbilityContext)

    // פונקציה פנימית שמרנדרת את הראוטים, כדי שנוכל לקרוא לה ברקורסיה עבור ילדים
    const renderRoutes = (routesArray) => {
        return routesArray.map((route, index) => {
            // אם אין הרשאה, לא מרנדרים את הראוט כלל
            if (!ability.can(route.role, route.feature)) return null;

            return (
                <Route
                    key={route.id || index}
                    path={route.path}
                    element={
                        route.navigate ?
                            <Navigate to={route.navigate} /> :
                            <WrapAppRoute {...route}>
                                <route.element />
                            </WrapAppRoute>
                    }
                >
                    {/* אם לראוט יש תתי-נתיבים, נרנדר אותם בתוך הראוט הזה */}
                    {route.children && renderRoutes(route.children)}
                </Route>
            )
        })
    }

    return (
        <Routes>
            {renderRoutes(routes)}
        </Routes>
    );
}

export default CreateRouter